import React from "react"
import {dateTimePrint} from '../../common/methods/CommonUtil';


function OfferDeliveryPeriod(props) {
  let datest = new Date(props.startTime);
  let dateen = new Date(props.endTime);

  return (
      <dd className="detail-info__text">
        {dateTimePrint(props.language , datest, 'YYYYMMDDY')}〜{dateTimePrint(props.language , dateen, 'YYYYMMDDY')}
      </dd>
  )
}

export default OfferDeliveryPeriod
